import { format } from 'owa-localize';
import { makeGetRequest } from 'owa-ows-gateway';
import type { ConnectedAccountResponse } from '../contracts/ConnectedAccountResponse';
import type { ErrorResponse } from '../contracts/ErrorResponse';

const getConnectedAccountUrl: string = 'ows/beta/ConnectedAccounts/{0}';

export function getConnectedAccount(id: string): Promise<ConnectedAccountResponse | ErrorResponse> {
    return makeGetRequest(format(getConnectedAccountUrl, id), null);
}
